module.exports = __webpack_public_path__ + "img/plus.b93b6683.svg";